import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useReprocessTmaisNfce } from '@/features/tmaisNfces/hooks/useReprocessTmaisNfce'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useForm } from 'react-hook-form'

interface ReprocessTmaisNfceModalProps {
  tmaisNfceId?: string
}

export const ReprocessTmaisNfceModal = ({ tmaisNfceId }: ReprocessTmaisNfceModalProps) => {
  const queryClient = useQueryClient()
  const [isOpen, setIsOpen] = useState(false)

  const { mutate: reprocessTmaisNfce, isPending } = useReprocessTmaisNfce({
    id: tmaisNfceId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tmaisNfce', tmaisNfceId] })
      reset()
      setIsOpen(false)
    },
    onError: (error) => FormTransformers.errorsTransformer({ setError })(error),
  })

  const { reset, setError, handleSubmit } = useForm()

  const onSubmit = () => {
    reprocessTmaisNfce()
  }

  return (
    <Modal
      Trigger={
        <Button operationKlassToCheckPermission="Admin::Tmais::Nfces::Reprocess" type="button">
          Reprocessar
        </Button>
      }
      title="Reprocessar NFCe"
      subtitle="Para garantir um melhor sucesso no reprocessamento, certifique-se de que todos os produtos da NFCe estejam mapeados."
      subtitleClassName="mt-1 text-white-300"
      useCancellableFooter
      confirmButtonText="Reprocessar"
      confirmButtonIsLoading={isPending}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onConfirm={handleSubmit(onSubmit)}
    />
  )
}
